class BlogSection extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.maxIndex = 0;
    this.touchStartX = 0;
    this.touchEndX = 0;
    this.isAnimating = false;
    this.wheelTimeout = null;
    this.lastWheelTime = 0;
  }

  connectedCallback() {
    this.track = this.querySelector('.blog-section__track');
    this.slides = this.querySelectorAll('.blog-section__slide');
    this.prevBtn = this.querySelector('.blog-section__arrow--prev');
    this.nextBtn = this.querySelector('.blog-section__arrow--next');
    
    this.slidesPerView = window.innerWidth <= 768 ? 1 : 2;
    this.maxIndex = this.slides.length > this.slidesPerView ? this.slides.length - this.slidesPerView : 0;
    
    this.bindEvents();
    this.updateControls();
    
    setTimeout(() => {
      this.updateSlider();
    }, 100);
  }

  bindEvents() {
    this.prevBtn?.addEventListener('click', () => this.prev());
    this.nextBtn?.addEventListener('click', () => this.next());
    
    this.addEventListener('touchstart', (e) => this.handleTouchStart(e), { passive: true });
    this.addEventListener('touchend', (e) => this.handleTouchEnd(e), { passive: true });
    
    window.addEventListener('resize', () => this.handleResize());
    
    this.track.addEventListener('wheel', (e) => this.handleWheel(e), { passive: false });
  }

  handleTouchStart(e) {
    if (window.innerWidth <= 768) return;
    this.touchStartX = e.changedTouches[0].screenX;
  }

  handleTouchEnd(e) {
    if (window.innerWidth <= 768) return;
    this.touchEndX = e.changedTouches[0].screenX;
    this.handleSwipe();
  }

  handleSwipe() {
    if (this.isAnimating) return;
    
    const diff = this.touchStartX - this.touchEndX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        this.next();
      } else {
        this.prev();
      }
    }
  }

  handleWheel(e) {
    const now = Date.now();
    const timeSinceLastWheel = now - this.lastWheelTime;
    
    if (this.isAnimating || timeSinceLastWheel < 600) {
      e.preventDefault();
      return;
    }
    
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
      e.preventDefault();
      
      if (this.wheelTimeout) {
        clearTimeout(this.wheelTimeout);
      }
      
      this.wheelTimeout = setTimeout(() => {
        if (e.deltaX > 0) {
          this.next();
        } else {
          this.prev();
        }
        this.lastWheelTime = Date.now();
      }, 50);
    }
  }

  handleResize() {
    const newSlidesPerView = window.innerWidth <= 768 ? 1 : 2;
    if (newSlidesPerView !== this.slidesPerView) {
      this.slidesPerView = newSlidesPerView;
      this.maxIndex = this.slides.length > this.slidesPerView ? this.slides.length - this.slidesPerView : 0;
      this.currentIndex = Math.min(this.currentIndex, this.maxIndex);
      this.updateSlider();
    } else {
      this.updateSlider();
    }
  }

  prev() {
    if (this.currentIndex > 0 && !this.isAnimating) {
      this.isAnimating = true;
      this.currentIndex--;
      this.updateSlider();
      setTimeout(() => {
        this.isAnimating = false;
      }, 600);
    }
  }

  next() {
    if (this.currentIndex < this.maxIndex && !this.isAnimating) {
      this.isAnimating = true;
      this.currentIndex++;
      this.updateSlider();
      setTimeout(() => {
        this.isAnimating = false;
      }, 600);
    }
  }

  updateSlider() {
    if (!this.slides.length) return;
    
    const isMobile = window.innerWidth <= 768;
    
    // 手机端使用原生滚动，不需要 transform
    if (isMobile) {
      this.track.style.transform = '';
      return;
    }
    
    let translateX;
    
    const article = this.slides[0]?.querySelector('.blog-section__article');
    const divider = this.slides[0]?.querySelector('.blog-section__divider');
    const articleWidth = article?.offsetWidth || 789;
    
    // Calculate divider width including margins more accurately
    let dividerWidth = 0;
    if (divider) {
      const dividerStyles = getComputedStyle(divider);
      const marginLeft = parseFloat(dividerStyles.marginLeft) || 0;
      const marginRight = parseFloat(dividerStyles.marginRight) || 0;
      const width = divider.offsetWidth || 1;
      dividerWidth = width + marginLeft + marginRight;
    }
    
    const slideWidth = articleWidth + dividerWidth;
    const containerWidth = this.track.parentElement.offsetWidth;
    
    // Ensure precise calculation
    if (this.currentIndex === this.maxIndex && this.slides.length > this.slidesPerView) {
      const visibleSlidesWidth = this.slidesPerView * slideWidth - dividerWidth;
      translateX = -(this.slides.length * slideWidth - dividerWidth - containerWidth);
    } else {
      translateX = -(this.currentIndex * slideWidth);
    }
    
    // Round to avoid sub-pixel rendering issues
    translateX = Math.round(translateX);
    
    this.track.style.transform = `translateX(${translateX}px)`;
    this.updateControls();
  }

  updateControls() {
    if (this.prevBtn) {
      this.prevBtn.disabled = this.currentIndex === 0;
    }
    if (this.nextBtn) {
      this.nextBtn.disabled = this.currentIndex >= this.maxIndex;
    }
  }
}

customElements.define('blog-section', BlogSection);